module.exports = "/images/protected-2-year-seller.png?37af531f3ed859e57c7931f4845f5bc2";